import React, { FC } from 'react';
import { View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import EventCharts from '@components/machines/components/eventsChart';
import Paid from '@components/ncFiles/components/paid';
import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface NCFilePerformancePaidProps extends NavigationProps {}

const NCFilePerformancePaid: FC<NCFilePerformancePaidProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <View style={MACHINES_PAGES_CONTAINER_STYLES}>
        <EventCharts getContentElement={(props) => <Paid {...props} />} />
      </View>
    </MachinesProvider>
  );
};

export { NCFilePerformancePaid };
